
export class AccLedgerGroupmaster {
    public LEDGER_GROUP_ID!: number;
    public GROUP_CODE!: string;
    public GROUP_CODE_MANL!: string;
    public GROUP_NAME!: string;
    public GROUP_ALIAS!: string;
    public GROUP_UNDER!: string;
    public GROUP_HIERACHYLEVEL!: number;
    public GROUP_NATURE: any;
    public GROUP_GP_EFFECT!: number;
    public GROUP_SRNO!: number;
    public LOCK_DEFAULT!: number;
    public ALLOWTOP!: number;
    public ALLOWHIG!: number;
    public ALLOWMID!: number;
    public ALLOWLOW!: number;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string;
    public UPDATED_DATE!: string;
    public IS_ACTIVE!: boolean;
}

